// @flow
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { ArticleContent } from '../partials';
import { ToolbarContent } from '../components/Toolbar';

/**
 * En móvil la Toolbar "inline" del paquete se posiciona en `absolute` (bottom: 9px) contando con
 * un `padding-bottom` reservado que `ArticleContent` acaba pisando, así que los likes se montaban
 * encima del rating. En las cards de opinión la devolvemos al flujo normal (debajo del contenido).
 */
export const ReviewContent: any = styled(ArticleContent)`
  ${maxMediaQueries.phone`
    ${ToolbarContent} {
      position: static;
      margin-top: 12px;
    }
  `}
`;
